module.exports = __webpack_public_path__ + "static/img/step 3.b7d83e0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step 3.gif
// module id = GnAe
// module chunks = 1